import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { Inquiry, ContactUsParams } from '../contact-us.interface';

export const setInquiries = createAction(
  '[Contact Us Component] Set Inquiries',
  props<{ inquiries: BackendResponse<Inquiry>; params: ContactUsParams; pageNumber: number }>()
);

// Requests

export const loadInquiries = createAction('[Request/Api Contact Us] Load Inquiries', (params: ContactUsParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));
